import React from 'react';
import { GroceryItem } from '../../types';
import { QuantityControls } from './QuantityControls';

interface GroceryItemCardProps {
  item: GroceryItem;
  onToggleBought: (item: GroceryItem) => void;
  onToggleImportant: (item: GroceryItem) => void;
  onQuantityChange: (item: GroceryItem, delta: number) => void;
  onEdit: (item: GroceryItem) => void;
  compact?: boolean;
}

export const GroceryItemCard: React.FC<GroceryItemCardProps> = ({
  item,
  onToggleBought,
  onToggleImportant,
  onQuantityChange,
  onEdit,
  compact = false,
}) => {
  return (
    <div
      className={`
        w-full flex items-center justify-between
        bg-white rounded-2xl
        shadow-soft transition-all duration-200
        hover:shadow-medium hover:-translate-y-0.5
        ${compact ? 'p-2' : 'p-3'}
        ${item.bought ? 'opacity-60' : ''}
        ${item.important && !item.bought ? 'border-2 border-warning' : 'border border-gray-200'}
      `}
    >
      <div
        className={`flex items-center flex-1 cursor-pointer min-w-0 ${compact ? 'gap-2' : 'gap-3'}`}
        onClick={() => onToggleBought(item)}
      >
        <span className={`flex-shrink-0 ${compact ? 'text-lg' : 'text-2xl'}`}>{item.emoji}</span>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1">
            <h3
              className={`font-medium truncate ${compact ? 'text-sm' : 'text-base'} ${
                item.bought ? 'line-through text-gray-500' : 'text-gray-900'
              }`}
              onClick={(e) => { e.stopPropagation(); onEdit(item); }}
            >
              {item.name}
            </h3>
            <button
              type="button"
              className={`flex-shrink-0 leading-none transition-all duration-200 ${compact ? 'text-base' : 'text-xl'} ${
                item.important && !item.bought ? 'text-warning scale-110' : 'text-gray-300 hover:text-warning'
              }`}
              onClick={(e) => { e.stopPropagation(); onToggleImportant(item); }}
              aria-label="Marquer comme important"
            >
              ★
            </button>
          </div>
          {!compact && <p className="text-sm text-gray-500 truncate">{item.type}</p>}
        </div>
      </div>

      {!item.bought && !compact && (
        <QuantityControls
          quantity={item.quantity}
          onIncrease={() => onQuantityChange(item, 1)}
          onDecrease={() => onQuantityChange(item, -1)}
          className="ml-3 flex-shrink-0"
        />
      )}
    </div>
  );
};
